import { NgModule } from '@angular/core';

import { SgCoreModule } from '@sg/ui-kit/core';
import { SgInputSliderModule } from '@sg/ui-kit/input-slider';
import { SgContentSliderModule } from '@sg/ui-kit/content-slider';
import { SgFormFieldModule } from '@sg/ui-kit/form-field';
import { SgObjectViewModule } from '@sg/ui-kit/object-view';
import { SgClickConfirmModule } from '@sg/ui-kit/click-confirm';
import { SgAsyncGuiModule } from '@sg/ui-kit/async-gui';
import { SgStepsProgressBarModule } from '@sg/ui-kit/steps-progress-bar';

export { SgCoreModule } from '@sg/ui-kit/core';
export { SgInputSliderModule } from '@sg/ui-kit/input-slider';
export { SgContentSliderModule } from '@sg/ui-kit/content-slider';
export { SgFormFieldModule } from '@sg/ui-kit/form-field';
export { SgObjectViewModule } from '@sg/ui-kit/object-view';
export { SgClickConfirmModule } from '@sg/ui-kit/click-confirm';
export { SgAsyncGuiModule } from '@sg/ui-kit/async-gui';
export { SgStepsProgressBarModule } from '@sg/ui-kit/steps-progress-bar';
import { SgAuxRouteBridgeModule } from '@sg/ui-kit/aux-route-bridge';
import { SgAutoCompleteSelectModule } from '@sg/ui-kit/auto-complete-select/src';
import { SgCookiesConsentModule } from '@sg/ui-kit/cookies-consent-dialog/src';
import { SgInspectorWizardModule } from './inspector-wizard-dialog/src';

const importAndExport = [
  SgCoreModule,
  SgInputSliderModule,
  SgContentSliderModule,
  SgFormFieldModule,
  SgObjectViewModule,
  SgClickConfirmModule,
  SgAsyncGuiModule,
  SgAuxRouteBridgeModule,
  SgAutoCompleteSelectModule,
  SgStepsProgressBarModule,
  SgCookiesConsentModule,
  SgInspectorWizardModule,
];

@NgModule({
  imports: [importAndExport],
  exports: [importAndExport],
})
export class SgUiKitModule {}
